
<div id="criterios-popup">
    <form class="form" role="form" autocomplete="off" [formGroup]="addConvenioCriteriosForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Add Criterios</h2>
        </div>
        <div class="popoup-content">
            <mat-error *ngIf="formFiled" class="common-error">
                <span> Se debe rellenar almenos un campo</span>
              </mat-error>
                <div class="each">
                    <mat-label class="label">Días de baja (Desde)</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input  min="1" max="545" matInput type="number" formControlName="diasDesde">
                    </mat-form-field>

                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('diasDesde').invalid && addConvenioCriteriosForm.get('diasDesde').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('diasDesde').hasError('min')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>      
                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('diasDesde').invalid && addConvenioCriteriosForm.get('diasDesde').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('diasDesde').hasError('max')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>
                </div>
                <div class="each">
                    <mat-label class="label">Días de baja (Hasta)</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input   min="1" max="545" matInput type="number" formControlName="diasHasta">
                    </mat-form-field>

                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('diasHasta').invalid && addConvenioCriteriosForm.get('diasHasta').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('diasHasta').hasError('min')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>      
                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('diasHasta').invalid && addConvenioCriteriosForm.get('diasHasta').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('diasHasta').hasError('max')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>
                </div>
                <div class="each">
                    <mat-label class="label">Complemento</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input  min="0" max="100" matInput type="number" formControlName="complemento">
                    </mat-form-field>

                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('complemento').invalid && addConvenioCriteriosForm.get('complemento').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('complemento').hasError('min')">
                            Introduce un valor entre 0 y 100
                        </span>
                    </mat-error>      
                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('complemento').invalid && addConvenioCriteriosForm.get('complemento').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('complemento').hasError('max')">
                            Introduce un valor entre 0 y 100
                        </span>
                    </mat-error>
                </div>
                <div class="each">
                    <mat-label class="label">Duración de la baja (Desde)</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input  min="1" max="545" matInput type="number" formControlName="bajasDesdeDias">
                    </mat-form-field>

                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('bajasDesdeDias').invalid && addConvenioCriteriosForm.get('bajasDesdeDias').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('bajasDesdeDias').hasError('min')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>      
                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('bajasDesdeDias').invalid && addConvenioCriteriosForm.get('bajasDesdeDias').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('bajasDesdeDias').hasError('max')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>
                </div>
                <div class="each">
                    <mat-label class="label">Duración de la baja (Hasta)</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input  min="1" max="545" matInput type="number" formControlName="bajasHastaDias">
                    </mat-form-field>

                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('bajasHastaDias').invalid && addConvenioCriteriosForm.get('bajasDesdeDias').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('bajasHastaDias').hasError('min')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>      
                    <mat-error class="fix-err" *ngIf="addConvenioCriteriosForm.get('bajasHastaDias').invalid && addConvenioCriteriosForm.get('bajasHastaDias').touched">
                        <span *ngIf="addConvenioCriteriosForm.get('bajasHastaDias').hasError('max')">
                            Introduce un valor entre 1 y 545
                        </span>
                    </mat-error>
                </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSave()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="onClose()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>